import React from 'react';
import { FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { StyledUiRadioGroup } from './UiRadioGroup.styles';

const UiRadioGroup = ({ name, control, children, ...otherProps }) => {
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <StyledUiRadioGroup {...field} {...otherProps}>
              {children}
            </StyledUiRadioGroup>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </>
        )}
      />
    );
  }

  return (
    <StyledUiRadioGroup name={name} {...otherProps}>
      {children}
    </StyledUiRadioGroup>
  );
};

UiRadioGroup.propTypes = {
  children: PropTypes.node,
  control: PropTypes.object,
  name: PropTypes.string,
};

export default UiRadioGroup;
